import type { CodeWorldSlug } from '@vrlearning/lesson-schema';

/**
 * Slugs whose code world a published package took over (ADR-049, W12): the platform's list
 * (`GET /v1/platform/worlds/taken-over`), copied here before a headset release. taken-over.test.ts
 * fails while one of them is still in WORLD_DEFINITIONS; remove that world's definition (its shared
 * parts stay: the villa builds from coast.ts) and its registry entry, then the test passes.
 */
export const TAKEN_OVER = [
  'beach',
  'forest',
  'meadow',
  'modern-street',
  'museum-hall',
  'polder',
  'science-lab',
  'sea-floor',
  'town-square',
  'villa',
  'volcanic-island',
] as const satisfies readonly CodeWorldSlug[];

/**
 * What the desktop preview says when a taken-over slug has no served package (`?world=<slug>` brings
 * none; a demo build carries one only with `pnpm demo:build --werelden`): the code world is gone, so it shows the studio. Undefined for
 * any other slug.
 */
export function takenOverNote(
  slug: string,
  taken: readonly string[] = TAKEN_OVER,
): string | undefined {
  return taken.includes(slug)
    ? `De wereld "${slug}" is een pakket geworden en heeft geen code meer: open de les met ?pakket=, in de test-drive of in een sessie.`
    : undefined;
}
